module.exports = __webpack_public_path__ + "07_face.901cf410.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer1/07_face.png
// module id = tTUs
// module chunks = 0